const CONFIG = {
  NAME: 'PRODUCTION',
  BASE_CALL_URL: 'https://mrs.doctor4u.vn',
  BASE_IMAGE_URL: 'https://mrs.doctor4u.vn/openmrs',
  BASE_API_URL: 'https://mrs.doctor4u.vn/openmrs/ws/rest',
};
export default CONFIG;
